import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class MachineBoardService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
constructor(private http: HttpClient) { }

getGroupList(data: any): Observable<any[]> {
  return this.http.post<any[]>(
    this.baseUrl + 'Common/GetGroup', data
  );
}

GetMachineDashboard(data: any): Observable<any[]> {
  return this.http.post<any[]>(
    this.baseUrl + 'SDFC/GetMachineDashboard', data
  );
}

GetPlantHeirarchyDashboard(data: any): Observable<any[]> {
  return this.http.post<any[]>(
    this.baseUrl + 'SDFC/GetPlantHeirarchyDashboard', data
  );
}

}
